import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import 'rxjs/add/operator/finally';

import { StatisticService } from '../../../../services/statistic.service';
import { UserService } from '../../../../services/user.service';
import { StatisticSubscription } from '../../../../entities/index';
import { Log } from '../../../../utils/index';

@Component({
  selector: 'app-dashboard-subscription',
  templateUrl: './dashboard-subscription.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DashboardSubscriptionComponent implements OnInit {
  subscriptionStats: StatisticSubscription = new StatisticSubscription();
  loading = false;
  siteAdmin: string = null;
  hasSubscriptionStats = false;

  constructor(protected statisticService: StatisticService,
              protected userService: UserService,
              protected cd: ChangeDetectorRef) {
  }

  @Log()
  ngOnInit() {
    this.watchCurrentUser();
  }

  @Log()
  watchCurrentUser() {
    this.userService.currentUser.subscribe(user => {
      if (user && user.id) {
        this.siteAdmin = user.role_site;
        this.hasSubscriptionStats = (!user.role_site && !user.role_retailer_id) || Boolean(user.role_site);
        this.getSubscriptionStats();
      } else {
        this.siteAdmin = null;
        this.hasSubscriptionStats = false;
        this.cd.markForCheck();
      }
    });
  }

  @Log()
  getSubscriptionStats() {
    this.loading = true;
    this.statisticService.subscriptionStats(this.siteAdmin)
      .finally(() => this.loading = false)
      .subscribe((res: StatisticSubscription) => {
        this.subscriptionStats = res;
        this.cd.markForCheck();
      });
  }
}



// WEBPACK FOOTER //
// /builds/weenect1/backofficev3/src/app/components/pages/dashboard/subscription/dashboard-subscription.component.ts